import { MathUtils } from "three"

const lerpNumber = MathUtils.lerp

export default lerpNumber
